// src/Landing.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 to-blue-200 px-6">
    <div className="bg-white shadow-xl rounded-xl p-10 max-w-xl text-center space-y-6">
    <img src="/realmaplogo.png" alt="RealMap Logo" className="w-20 mx-auto" />
    <h1 className="text-4xl font-bold text-blue-700">RealMaps</h1>
    <h2 className="text-xl text-gray-800">Explore Property Sales in Monmouth County</h2>
    <p className="text-gray-600 leading-relaxed">
      Search real estate transactions, visualize trends, and gain insights from verified county data.
    </p>
    <button
      onClick={() => navigate("/about")}
      className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition"
    >
      Get Started
    </button>
  </div>
</div>

  );
}
